import { JSX } from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    SelectInput,
    ReferenceInput,
} from 'react-admin';
import {
    LinearProgress,
} from '@mui/material';
import { useGetCountries } from "../global-hooks/default-system-hooks";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const AdminCompaniesHouseAddressCreate: () => JSX.Element = (): JSX.Element => {
    const { loadedCountries, loading } = useGetCountries();
    return (
        <Create>
            <SimpleForm>
                <TextInput name="line_one" source="line_one" validate={[required()]} fullWidth />
                <TextInput name="line_two" source="line_two" fullWidth />
                <TextInput name="city" source="city" validate={[required()]} fullWidth />
                <TextInput name="county" source="county" fullWidth />
                { (loading) &&
                    <LinearProgress sx={ { margin: '10px 0', width: '75%' } } />
                }
                { (!loading) &&
                    <SelectInput
                        choices={ loadedCountries }
                        source="country"
                        optionValue="id"
                    />
                }

                <TextInput name="postcode" source="postcode" validate={[required()]} fullWidth />
                <ReferenceInput
                    label="Companies House For"
                    name="Companies House For"
                    source="companiesHouse"
                    reference="companies_house">
                    <SelectInput optionText="companyName"  validate={[required()]}/>
                </ReferenceInput>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}